import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "container" }

import LeftMenu from "@/components/com/LeftMenu"
	import Nav from "@/components/com/Nav"
	import Bread from "@/components/com/Bread"
	import Content from "@/components/com/Content"
	import { useStore } from 'vuex'
	
export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

	const {dispatch} = useStore()
	
	dispatch('publicOptions/getplatformInfo', 'needload')
	dispatch('publicOptions/getPersonInfo')
	// dispatch('publicOptions/getMenuList')

return (_ctx: any,_cache: any) => {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, { class: "body-container" }, {
    default: _withCtx(() => [
      (_ctx.$route.meta.showLeftMenu)
        ? (_openBlock(), _createBlock(_unref(LeftMenu), { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_container, { class: "main-container" }, {
        default: _withCtx(() => [
          (_ctx.$route.meta.showNav)
            ? (_openBlock(), _createBlock(_component_el_header, {
                key: 0,
                class: _normalizeClass({bread: _ctx.$route.meta.showBread})
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Nav)),
                  (_ctx.$route.meta.showBread)
                    ? (_openBlock(), _createBlock(_unref(Bread), { key: 0 }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["class"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_main, {
            class: _normalizeClass(["body-main", {pad0: !_ctx.$route.meta.showLeftMenu && !_ctx.$route.meta.showNav}])
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_unref(Content))
              ])
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})